import Text from '../../../components/Typography/Text'

import Modal from './Modal'

type Props = {
  cancelText?: string
  centered?: boolean
  children: React.ReactNode
  confirmText?: string
  confirmTestId?: string
  isDestructive?: boolean
  isLoading?: boolean
  onCancel: () => void
  onConfirm: (() => void) | (() => Promise<unknown>)
  /**
   * Customize which element receives focus when the modal closes; by default it is the element that triggered the modal, but you will need to set this if the trigger no longer exists (e.g. a menu item)
   */
  onCloseFocusRef?: React.RefObject<HTMLElement>
  /**
   * Visible modal header and dialog accessible name. Use Title Case (e.g. "Delete Holiday",
   * "Discard Changes"), consistent with other `Modal.Header` titles. Display is normalized
   * in `Modal.Header` when sentence case is passed by mistake.
   */
  title: string
}
const ConfirmationModal = ({
  cancelText,
  centered,
  children,
  confirmText,
  confirmTestId,
  isDestructive,
  isLoading,
  onCancel,
  onConfirm,
  onCloseFocusRef,
  title,
}: Props) => {
  return (
    <Modal onClose={onCancel} onCloseFocusRef={onCloseFocusRef} centered={centered}>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>
        {typeof children === 'string' ? <Text>{children}</Text> : children}
      </Modal.Content>
      <Modal.Footer
        cancelText={cancelText}
        confirmText={confirmText}
        confirmTestId={confirmTestId}
        isDestructive={isDestructive}
        onConfirm={onConfirm}
        isLoading={isLoading}
      />
    </Modal>
  )
}

export default React.memo(ConfirmationModal)
